module.exports = __webpack_public_path__ + "img/purchase--icon.227f73cd.svg";